import "../../components/Styles/Comparer.css";
import FirstPage from "./FirstPage/FirstPage";
import SecondPage from "./SecondPage/SecondPage";
import ThirdPage from "./ThirdPage/ThirdPage";
import FourthPage from "./FourthPage/FourthPage";
import FifthPage from "./FifthPage/FifthPage";
import LoginPage from "./LoginPage/LoginPage";
import Steps from "../../components/Steps/Steps";
import React, { Component } from "react";
import CreditLengthChange from "../../classes/CreditLengthChange";
import CreditMarginChange from "../../classes/CreditMarginChange";
import CreditSubsequentsTranchesChange from "../../classes/CreditSubsequentsTranchesChange";
import CreditEarlyRepaymentChange from "../../classes/CreditEarlyRepaymentChange";
import Swal2 from "sweetalert2";
import swal from "sweetalert";
import withReactContent from "sweetalert2-react-content";
import Header from "../../components/Header/Header";
import { secret } from "./data";

const MySwal = withReactContent(Swal2);

class Comparer extends Component {
  state = {
    step: 1,
    page: 1,
    userCreditData: "",
    userAnalysisData: "",
    total_benefit: 0,
    userContactData: "",
    scripturl: "",
    analysis: 0,
    companies: [],
    companiesData: [],
    companiesDescription: [],
    companiesFiles: [],
    companiesOffer: [],
    chooseCompanyArray: [],
    clientAcceptPolicy: false,
    newAssingmentDate: "",
    companyJudgments: [],
    viewFull: false,
    analysisReady: false,
    leadId: "",
    analysisLink: "",
  };

  componentDidMount() {
    this.fetchScript();
    this.checkStartup();
  }

  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] === variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    return false;
  }

  checkStartup = () => {
    if (+this.getQueryVariable("login") === 1) {
      this.setState({
        page: 5,
        step: 5,
        stepsDisplay: true,
      });
    } else if (+this.getQueryVariable("redirect") === 1) {
      this.setState({
        page: 2,
        step: 2,
        stepsDisplay: true,
        creditBank: "mBank S.A. - BRE Bank S.A. | Umowa z 2004 r. mPlan", //to FIX redirect bank data
        creditAmmount: +this.getQueryVariable("ammount"),
        creditCurrency: this.getQueryVariable("currency"),
        creditDate: this.getQueryVariable("date"),
      });
    }
  };

  fetchScript = () => {
    fetch("https://api.twojeskd.pl/scripturl")
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          scripturl: data[0].url,
        });
      });
  };

  addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  componentDidUpdate() {}

  clientAcceptPolicy = (e) => {
    this.setState((prevState) => ({
      clientAcceptPolicy: e.target.checked,
    }));
  };

  setCreditData = (data) => {
    this.setState((prevState) => ({
      userCreditData: data,
    }));
    this.setNewCalculate(data);
  };

  setNewCalculate(data) {
    var options, url;

    var payload = {
      clientBank: data.creditBank,
      clientCreditValuePLN: data.creditAmmount,
      clientCreditStartDate: data.creditDate,
      clientCreditMargin: data.creditMargin / 100,
      clientCreditLength: data.creditLength,
      clientCreditCurrency: "PLN",
      comission: data.creditComission,
    };

    url = this.state.scripturl;
    options = {};
    options.method = "post";
    options.payload = JSON.stringify(payload);

    fetch(url, {
      method: "post",
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        this.setState({
          userAnalysisData: data,
          total_benefit: +data.cancel_total_benefit,
          analysisReady: true,
        });
        if (this.state.leadId !== "") {
          var body = {
            leadId: this.state.leadId,
            analysis: data.file_id,
          };

          fetch("https://api.twojeskd.pl/insert_lead_detail", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secret,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log(data);
              this.setState({
                analysisLink: data.link,
              });
            })
            .catch((error) => {});
        }
      });
  }

  handleFocus = (e) => {
    e.target.value = 0;
    e.target.select();
  };

  changeValidate = (value) => {
    if (value === 1) {
      this.setState((prevState) => ({
        validate1: 1,
      }));
    } else if (value === 2) {
      this.setState((prevState) => ({
        validate2: 1,
      }));
    } else if (value === 3) {
      this.setState((prevState) => ({
        validate3: 1,
      }));
    }
  };

  arrayRemove = (arr, value) => {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  };

  goToThirdPage = (data) => {
    this.setState({ userContactData: data, page: 3, step: 3 });

    window.fbq("trackCustom", "contactPorSKD");
    window.gtag("event", "conversion", {
      send_to: "AW-11435982333/dqjoCPaGidsZEP37jM0q",
      value: 1000.0,
      currency: "PLN",
    });

    var body = {
      name: this.state.userContactData.userName,
      phone: this.state.userContactData.userPhone,
      mail: this.state.userContactData.userMail,
      creditAgreement: this.state.userCreditData.creditBank,
      creditAmmount: this.state.userCreditData.creditAmmount,
      creditDate: this.state.userCreditData.creditDate,
      creditCurrency: this.state.userCreditData.creditCurrency,
      leadArea: this.state.userContactData.userRegion,
      leadExpectations: this.state.userContactData.userExpectations,
      noContact: this.state.userContactData.noContact,
    };

    fetch("https://api.twojeskd.pl/insert_lead_basic", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secret,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        this.setState({ leadId: data.insertId });
        if (this.state.total_benefit > 0) {
          var body = {
            leadId: data.insertId,
            analysis: this.state.userAnalysisData.file_id,
          };

          fetch("https://api.twojeskd.pl/insert_lead_detail", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secret,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((data) => {
              this.setState({
                analysisLink: data.link,
              });
            })
            .catch((error) => {});
        }
      })
      .catch((error) => {});
  };

  render() {
    return (
      <>
        <Header />

        <Steps
          stepNumber={this.state.step}
          changeStep={this.changePageBySteps}
        />

        {this.state.page === 1 ? (
          <FirstPage
            onSubmitFirstForm={this.onSubmitFirstForm}
            changeStep={this.changePageBySteps}
            setCreditData={this.setCreditData}
            goToThirdPage={this.goToThirdPage}
          />
        ) : this.state.page === 2 ? (
          <SecondPage
            userCreditData={this.state.userCreditData}
            userContactData={this.state.userContactData}
            onSubmitSecondForm={this.onSubmitSecondForm}
            analysisReady={this.state.analysisReady}
            goToThirdPage={this.goToThirdPage}
            total_benefit={this.state.total_benefit}
          />
        ) : this.state.page === 3 ? (
          <ThirdPage
            userCreditData={this.state.userCreditData}
            userContactData={this.state.userContactData}
            analysisReady={this.state.analysisReady}
            userAnalysisData={this.state.userAnalysisData}
            total_benefit={this.state.total_benefit}
            analysis_link={this.state.analysisLink}
            leadId={this.state.leadId}
          />
        ) : (
          ""
        )}
      </>
    );
  }
}

export default Comparer;
